import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {
    title: "Trouvez le professionnel le plus proche de chez vous",
    markerInfos: "Cliquez sur le professionnel de votre choix pour fixer un premier rendez-vous",
    filterInput: {
        placeholderPro: "Nom, Spécialité",
        placeholderMarker: "Où ?"
    },
    rdvButton: "Prendre rendez-vous",
    on: "le",
    html: {
        proName: "NOM Prénom",
        proSpecialty: "Spécialité",
        proAddress: "Adresse"
    },
    noProConsent: "Ce professionnel ne nous a pas encore rejoints !",
    noProducts: "Ce professionnel ne propose aucun rendez-vous pour l'instant",
    rdvButtonTimeFormat: "dd LLL 'à' HH:mm"
};

export type _I18nScheduleMap = typeof _fr;

const _en: _I18nScheduleMap = {
    title: "Find your nearest coach",
    markerInfos: "Filter and click on the coach of your choice to make an initial appointment",
    filterInput: {
        placeholderPro: "Name, Speciality",
        placeholderMarker: "Where ?"
    },
    rdvButton: "Make an appointment on",
    on: "on",
    html: {
        proName: "LASTNAME Firstname",
        proSpecialty: "Specialty",
        proAddress: "Address"
    },
    noProConsent: "This professional didn't join us yet",
    noProducts: "This professional doesn't accept appointments for the moment",
    rdvButtonTimeFormat: "dd LLL 'at' HH:mm"
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function I18nScheduleMap(lang?: string): _I18nScheduleMap {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}